// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '32px',
  height: '32px',
  color: '',
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

// Component
function IconNotificationConcern({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 43.554 37"
    >
      <g transform="translate(-15.446 -23)">
        <g transform="translate(22 23)">
          <circle fill="#2a428c" cx="18.5" cy="18.5" r="18.5" />
        </g>
        <g transform="translate(22.446 24.052)">
          <path
            fill="#d3dcfb"
            d="M52.694,36.525c0,6.166-6.646,11.162-14.847,11.162a18.812,18.812,0,0,1-6.528-1.138c-4.67,3.388-7.984,2.144-7.984,2.144A9.575,9.575,0,0,0,26.9,44.069,9.8,9.8,0,0,1,23,36.525c0-6.17,6.646-11.166,14.847-11.166S52.694,30.355,52.694,36.525Z"
            transform="translate(-30 -26.359)"
          />
          <g transform="translate(-1.291 8.469)">
            <path
              fill="#575b6d"
              d="M39.195,48.294A1.694,1.694,0,1,1,37.5,46.6,1.694,1.694,0,0,1,39.195,48.294Z"
              transform="translate(-35.807 -46.6)"
            />
            <path
              fill="#575b6d"
              d="M55.9,48.294A1.694,1.694,0,1,1,54.2,46.6,1.694,1.694,0,0,1,55.9,48.294Z"
              transform="translate(-45.064 -46.6)"
            />
            <path
              fill="#575b6d"
              d="M72.6,48.294A1.694,1.694,0,1,1,70.9,46.6,1.694,1.694,0,0,1,72.6,48.294Z"
              transform="translate(-54.32 -46.6)"
            />
          </g>
          <path
            fill="#fa6383"
            d="M49.929,68.186c0,5.1,5.495,9.228,12.275,9.228a15.552,15.552,0,0,0,5.4-.941c3.86,2.8,6.6,1.773,6.6,1.773a7.916,7.916,0,0,1-2.95-3.823,8.1,8.1,0,0,0,3.227-6.236c0-5.1-5.495-9.231-12.275-9.231s-12.275,4.13-12.275,9.231Z"
            transform="translate(-37.925 -43.978)"
          />
          <circle
            fill="#fff"
            cx="1.408"
            cy="1.408"
            r="1.408"
            transform="translate(29.053 22.798)"
          />
          <circle
            fill="#fff"
            cx="1.408"
            cy="1.408"
            r="1.408"
            transform="translate(22.872 22.798)"
          />
          <circle
            fill="#fff"
            cx="1.408"
            cy="1.408"
            r="1.408"
            transform="translate(16.69 22.798)"
          />
        </g>
      </g>
    </svg>
  )
}

IconNotificationConcern.defaultProps = defaultProps
IconNotificationConcern.propTypes = propTypes

export default IconNotificationConcern
